import type React from 'react'
import type { CustomersByCountryDto } from '../../../../../../types/coreApi-types'

interface CustomersByCountryTableProps {
  data: CustomersByCountryDto[]
}

const CustomersByCountryTable: React.FC<CustomersByCountryTableProps> = ({
  data,
}) => {
  return (
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead>
          <tr className="border-b border-gray-200">
            <th className="text-left py-3 px-4 font-semibold text-sm text-gray-700">
              Country
            </th>
            <th className="text-right py-3 px-4 font-semibold text-sm text-gray-700">
              Customer Count
            </th>
            <th className="text-right py-3 px-4 font-semibold text-sm text-gray-700">
              Percentage of Total
            </th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <tr
              key={item.country}
              className={`border-b border-gray-100 ${
                index % 2 === 0 ? 'bg-gray-50' : 'bg-white'
              } hover:bg-gray-100 transition-colors`}
            >
              <td className="py-3 px-4 text-sm font-medium">{item.country}</td>
              <td className="py-3 px-4 text-sm text-right">
                {item.customerCount}
              </td>
              <td className="py-3 px-4 text-sm text-right">
                {item.percentageOfTotal.toFixed(2)}%
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {data.length === 0 && (
        <div className="text-center py-8 text-gray-500">
          No country data available
        </div>
      )}
    </div>
  )
}

export default CustomersByCountryTable
